/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PhaseCountEnum = 1 | 2 | 3;

export const PhaseCountEnum = {
    NUMBER_1: 1 as PhaseCountEnum,
    NUMBER_2: 2 as PhaseCountEnum,
    NUMBER_3: 3 as PhaseCountEnum
};

